import { BlogSectionType } from '../../../models/Content';

export const transformSectionQuote = (content: BlogSectionType) => {
    return {
        quote: content.fields.text,
        author: content.fields.author,
    };
};
